import { render, staticRenderFns } from "./notifications-icon.vue?vue&type=template&id=28f6e429"
import script from "./notifications-icon.vue?vue&type=script&lang=js"
export * from "./notifications-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports